import { Tooltip } from "antd";
import { ReactNode } from "react";

interface IMenuItemLabel {
    text: string;
    showTooltip: boolean;
    tooltipText?: ReactNode
}

const MenuItemLabel = ({ text, showTooltip, tooltipText }: IMenuItemLabel) => {
    return showTooltip ?
        <Tooltip title={tooltipText}>
            {text}
        </Tooltip> :
        <>{text}</>;
}

export default MenuItemLabel;